import React from 'react'
import { observer } from 'mobx-react'
import calculator from './calculator.js'
import UINumber from './UINumber.js'
import constants from './constants'

@observer
class MaxAllowedTemperatureControl extends React.Component {
  render() {
    return (
      <UINumber
        label="Max Temp"
        value={calculator.maxAllowedTemperatureCelcius}
        onChange={(e) => calculator.maxAllowedTemperatureCelcius = parseFloat(e.target.value)}
        validateOnChange={e => {
          const val = parseFloat(e.target.value)
          if(val < constants.minAllowedTemperatureCelcius) {
            return `Temp must be between ${constants.minAllowedTemperatureCelcius}˚C and +${constants.maxAllowedTemperatureCelcius}˚C`
          }
          else if(val > constants.maxAllowedTemperatureCelcius) {
            return `Temp must be between ${constants.minAllowedTemperatureCelcius}˚C and +${constants.maxAllowedTemperatureCelcius}˚C`
          }
          else if(val <= calculator.ambientTemperatureCelcius) {
            return `Max temp must be greater than ambient temp`
          }
        }}
        bsSize="sm"
        unit="°C"
        requireLoggedInUser={true}
      />
    )
  }
}

export default MaxAllowedTemperatureControl;
